import { Button } from '@sl/react-datafabric-components';
import { classNames } from 'primereact/utils';
import { useNavigate } from 'react-router-dom';
import AuthPageWrapper from '../../authenticated-user/pages/components/auth-page-wrapper';
import styles from '../../authenticated-user/pages/components/auth-styles.module.css';

const NoAccessPage = () => {
  const navigate = useNavigate();

  return (
    <AuthPageWrapper>
      <div className='px-5 min-h-screen flex justify-content-center align-items-center'>
        <div className='z-1 text-center'>
          <div className='text-900 font-bold text-8xl mb-4'>Oops!</div>
          <p className='line-height-3 mt-0 mb-5 text-700 text-xl font-medium'>
            Your agent is not active. Please activate your agent to access this
            page.
          </p>
          <Button
            label='Go Home'
            icon='pi pi-home'
            className={classNames(styles.mainButton, 'border-noround')}
            onClick={() => navigate('/')}
          />
        </div>
      </div>
    </AuthPageWrapper>
  );
};

export default NoAccessPage;
